<script>
import HeaderView from '../../../shared/views/HeaderView';
import MainMenuInstructorView from '../../../shared/views/MainMenuInstructorView';
import HomeInstructorDashboardView from '../dashboards/HomeInstructorDashboardView';

export default {
  components: {
    'main-menu-instructor-view': MainMenuInstructorView,
    'header-view': HeaderView,
    'home-instructor-dashboard-view': HomeInstructorDashboardView,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <h4 class="item_title">
                  <i class="uil uil-apps" /> Resumen
                </h4>
                <div class="la5lo1">
                  <home-instructor-dashboard-view />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>